// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--1h5qi";
export var formAndDetailsContainer = "contact-module--formAndDetailsContainer--1lk3K";
export var form = "contact-module--form--2qPUD";
export var submitBtn = "contact-module--submitBtn--1IkD8";
export var contactDetails = "contact-module--contactDetails--2Rnj5";
export var basicDetails = "contact-module--basicDetails--3bems";
export var basicDetail = "contact-module--basicDetail--1eToy";
export var socialLinks = "contact-module--socialLinks--1pY8x";
export var socialButtons = "contact-module--socialButtons--Cbk0T";